import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { toast } from 'sonner';

const ProductCard = ({ product, index = 0 }) => {
  const { addItem } = useCart();

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addItem(product);
    toast.success(`${product.name} added to cart`);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="group"
    >
      <Link 
        to={`/product/${product.id}`} 
        className="block"
        data-testid={`product-card-${product.id}`}
      >
        {/* Image */}
        <div className="relative aspect-[3/4] overflow-hidden bg-secondary/30 mb-4">
          <img
            src={product.image_url}
            alt={product.name}
            className="w-full h-full object-cover product-image-hover"
          />
          {/* Overlay on hover */}
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300" />
          
          {/* Quick add button */}
          <button
            onClick={handleAddToCart}
            className="absolute bottom-4 left-4 right-4 bg-gold text-black py-3 text-xs font-body tracking-widest uppercase opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-300 btn-shine flex items-center justify-center gap-2"
            data-testid={`quick-add-${product.id}`}
          >
            <ShoppingBag className="h-4 w-4" />
            Add to Bag
          </button>

          {/* Featured badge */}
          {product.featured && (
            <span className="absolute top-4 left-4 bg-gold text-black text-[10px] font-accent tracking-widest uppercase px-3 py-1">
              Featured
            </span>
          )}
        </div>

        {/* Details */}
        <div className="space-y-1">
          <h3 className="font-body text-sm tracking-wide text-foreground group-hover:text-gold transition-colors">
            {product.name}
          </h3>
          <p className="font-accent text-sm text-gold">
            ${product.price.toFixed(2)}
          </p>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
